module.exports = __webpack_public_path__ + "img/bulb.ada592d2.svg";